import { FunctionComponent, useEffect, useState } from 'react'
import styled from 'styled-components'
import Tag from '../../../components/Tag'
import Text from '../../../components/Text'
import { styles } from '../../../styles/themes/style'
import { IPrice } from '../../../interfaces/models/billingPlan'

interface IPlanValueProps {
    isSelected?: boolean
}

interface IPlanToggleProps extends IPlanValueProps {
    selectedInterval?: any,
    prices: IPrice[],
    selectedBillingPlan: any,
    onClickHandler?: (e: any) => void
}

// const calculateSaveAmount = (monthlyPrice?: IPrice, annualPrice?: IPrice): number => {
//     if(monthlyPrice && annualPrice) {
//         const annualMonthly = monthlyPrice?.price * 12
//         return (annualMonthly - annualPrice?.price) / annualMonthly * 10000
//     }
//     return 0
// }

const PlanToggle: FunctionComponent<IPlanToggleProps> = ({ selectedInterval, prices, onClickHandler, selectedBillingPlan }) => {

    useEffect(() => {
        if(selectedBillingPlan?.name === 'Starter' && prices.length === 1) {
            // as a monthly price is removed for the Starter plan, we need to add it to the prices array in order to show the both toggle buttons
            prices.push({
                _id: "",
                productId: prices[0].productId,
                interval: "month",
                currency: "usd",
                price: 0,
                priceId: "",
                active: true
            })
        }
    }, [selectedBillingPlan, prices])

    const plansInitialValues = [
        {
            plan: 'Yearly',
            key: 'year',
            currency: 'usd',
            price: 0,
            save: 'Save 30%'
        },
        {
            plan: 'Monthly',
            key: 'month',
            currency: 'usd',
            price: 0,
            save: ''
        }
    ]
    const [plansValues, setPlansValues] = useState<{
        plan: string,
        key: string,
        currency: string,
        price: number,
        save?: string
    }[]> (plansInitialValues)

    useEffect(() => {
        // Group prices by productId and interval to handle multiple prices per product
        const pricesByProductAndInterval: { [key: string]: IPrice[] } = {};
        prices.forEach(price => {
            const key = `${price.productId}-${price.interval}`;
            if (!pricesByProductAndInterval[key]) {
                pricesByProductAndInterval[key] = [];
            }
            pricesByProductAndInterval[key].push(price);
        });

        // Filter to get only active prices
        const activePrices: IPrice[] = [];
        Object.values(pricesByProductAndInterval).forEach(productIntervalPrices => {
            if (productIntervalPrices.length === 1) {
                // If only one price for this product+interval, keep it (backward compatibility)
                activePrices.push(productIntervalPrices[0]);
            } else {
                // If multiple prices, filter by active === true
                const activeProductPrices = productIntervalPrices.filter(price => price.active === true);
                if (activeProductPrices.length > 0) {
                    activePrices.push(...activeProductPrices);
                } else {
                    // Fallback: if no active prices found, keep the first one
                    activePrices.push(productIntervalPrices[0]);
                }
            }
        });
        
        let newPlans = activePrices.map(price => {
            return {
                plan: price.interval,
                key: price.interval,
                price: price.price,
                currency: price.currency
            }
        })
        newPlans = newPlans.map(plan => plan?.key === 'year' ? { ...plan, save: 'Save 30%' } : plan)
        setPlansValues(newPlans)
    }, [prices])

    return (
        <Container>
            {plansValues.sort((a: any, b: any) => {
                if(a.plan === 'year' && b.plan !== 'year') return -1
                if(a.plan !== 'year' && b.plan === 'year') return 1
                return 0
            }).map((value, index) => (
                    <PlanValue key={index} isSelected={selectedInterval?.key === value?.key} onClick={() => onClickHandler && onClickHandler({ plan: value?.plan, key: value?.key })}>
                        <Text $black $bold $capitalize>{`Bill ${value.plan}ly`}</Text>
                        {value?.save  && <Tag $color={styles.colors.green600} title={value?.save} />}
                    </PlanValue>
                ))}
        </Container>
    )
}
const Container = styled.div`
    display: flex
`
const PlanValue = styled.div<IPlanValueProps>`
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid ${({ isSelected }) => isSelected ? styles.colors.primary600 : styles.colors.white};
    border-radius: 4px;
    background-color: #EEF3FF;
    padding: 9px 8px;
    cursor: pointer;

    &:hover > span:first-child {
        color: #545E77;
    }
`
export default PlanToggle